import { render, staticRenderFns } from "./TaiwanPay.vue?vue&type=template&id=b98129a4"
import script from "./TaiwanPay.vue?vue&type=script&lang=js"
export * from "./TaiwanPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports